export enum RELATIONSHIP_STATUS {
  NONE = 0,
  DATING = 1,
  ENGAGED = 2,
  MARRIED = 3,
  OTHER = 4,
}
